import type { FaireProductEntity } from "../../entity_types/product";

export const p_2e9aggrqgk: FaireProductEntity = {
  token: "p_2e9aggrqgk",
  type: "product",
  name: "Red Bandana Fringe Crossbody",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/8f39f032e9f99a93e3367a9afd05f1a06cb647a8e41ef4c8da77c84128339e54.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1180b0b3fac369a6a00a8eb571549950f54698dad080b5ec419f4d785b99f76d.jpeg",
    "https://cdn.faire.com/fastly/04297588055ba0537b71fe2e0cd2f33e4e22de2492c96f005d749117b0912355.jpeg"
  ],
  priceDollars: 37.95,
  description: "A red bandana fringe crossbody featuring a classic paisley print, designed with a long crossbody strap and suede leather fringe detailing for a stylish western-inspired look. Roomy interior is perfect for carrying daily essentials while adding a statement touch to any outfit.\n\n14\" W x 10\" H\n\n100% Cotton\n\nMin. Qty: 2",
  tags: [],
  msrpDollars: 94.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:42.912Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
